import { apiSlice } from 'api/apiSlice'

const productVariantsApi = apiSlice.injectEndpoints({
  endpoints: build => ({
    getBuyBarCopy: build.query({
      query: ({ slug, country }) => ({
        app: 'sneakers',
        method: 'GET',
        url: `/web-api/v1/product_variants/buy_bar_copies?productTemplateId=${slug}&countryCode=${country}&timestamp=${new Date().getTime()}`,
      }),
    }),
  }),
})

export const { useGetBuyBarCopyQuery } = productVariantsApi
